<script>
export default {
    name: 'ArticleCard',
    props: {
        title: String,
        excerpt: String,
        link: String,
    },
};
</script>

<template>
    <article class="article-card">
        <router-link v-bind:to="link" class="article-card__title-link">
            <h1 class="article-card__title">{{ title }}</h1>
        </router-link>
        <p class="article-card__excerpt" v-if="excerpt">{{ excerpt }}</p>
        <router-link v-bind:to="link" class="article-card__link read-more">{{ $t('articles.readMore') }}</router-link>
    </article>
</template>

<style lang="scss">
.article-card__title-link {
    color: $color-primary;
    text-decoration: none;
}

.article-card__title {
    margin: 0;
    font-size: 4rem;
    font-style: normal;
    font-weight: 300;
    line-height: 120%;
    letter-spacing: 0.0859rem;
    text-wrap: balance;

    @include breakpoint('xs') {
        font-size: 3.2rem;
    }
}

.article-card__excerpt {
    font-size: 1.8rem;
    letter-spacing: 0.032rem;
    line-height: 1.67;
    margin-top: 2.4rem;
    margin-bottom: 0;

    @include breakpoint('xs') {
        margin-top: 1.6rem;
    }
}

.article-card__link {
    display: inline-block;
    margin-top: 3.2rem;
}
</style>
